import { render, staticRenderFns } from "./ApprovedRow.vue?vue&type=template&id=49eb10f9&"
import script from "./ApprovedRow.vue?vue&type=script&lang=js&"
export * from "./ApprovedRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports